"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditAssessmentFrequencyRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.CreditAssessmentFrequencyRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.credit_assessment_frequency.label',
    fallbackLabel: 'Credit assessment frequency',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'REVIEW_MULTIPLE_TIMES_A_YEAR', label: 'fields.enm.credit_assessment_frequency.options.REVIEW_MULTIPLE_TIMES_A_YEAR', fallbackLabel: 'Most or all merchants are reviewed multiple times within a year' },
        { key: 'REVIEW_ONCE_A_YEAR', label: 'fields.enm.credit_assessment_frequency.options.REVIEW_ONCE_A_YEAR', fallbackLabel: 'Most or all merchants are reviewed once a year' },
        { key: 'LESS_THAN_ONCE_A_YEAR', label: 'fields.enm.credit_assessment_frequency.options.LESS_THAN_ONCE_A_YEAR', fallbackLabel: 'Most or all merchants are reviewed less frequently than once a year' },
        { key: 'NO_REVIEWS', label: 'fields.enm.credit_assessment_frequency.options.NO_REVIEWS', fallbackLabel: 'We do not review our merchants based on a periodic schedule' },
    ],
    trackFieldValueWithAnalytics: false,
};
